import SwitchButtonField from './component'

export default SwitchButtonField
